import { render, staticRenderFns } from "./courseintroduction.vue?vue&type=template&id=7ebdd042&scoped=true"
import script from "./courseintroduction.vue?vue&type=script&lang=js"
export * from "./courseintroduction.vue?vue&type=script&lang=js"
import style0 from "./courseintroduction.vue?vue&type=style&index=0&id=7ebdd042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebdd042",
  null
  
)

export default component.exports